// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AvatarStatus-base__YWLrz{background-color:var(--status-color, var(--gray-8));border-radius:var(--border-radius-full)}.AvatarStatus-user__acVIN{width:.2em;height:.2em}.AvatarStatus-object__RAx9q{width:.16em;height:.16em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "AvatarStatus-base__YWLrz",
	"user": "AvatarStatus-user__acVIN",
	"object": "AvatarStatus-object__RAx9q"
};
export default ___CSS_LOADER_EXPORT___;
